import { render } from "./application-period-badge.vue?vue&type=template&id=acc10648"
import script from "./application-period-badge.vue?vue&type=script&lang=js"
export * from "./application-period-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__